/** Global sans font — must match CSS `--font-sans` */
export const APP_FONT_FAMILY =
  '"Inter", ui-sans-serif, system-ui, sans-serif';
